import { Col, Row, Typography } from "antd";
import { PACKAGE_FORM_MODE } from "features/LoyaltyPackage/core/constants";
import {
  getLoyaltyApplyScopeLabel,
  getLoyaltyTimeIntervalLabel,
  formatLoyaltyDatetime,
} from "features/LoyaltyPackage/core/utils";
import { t } from "i18next";

import { LoyaltyModal, LoyaltyModalFooter, LoyaltyModalTextTitle } from "../../../components/LoyaltyModal";

const { Text } = Typography;

function PackageConfirmModal({
  visible,
  mode = PACKAGE_FORM_MODE.CREATE,
  data,
  milestones,
  products,
  programTitle = "—",
  categoryName = "—",
  loading,
  onCancel,
  onConfirm,
}) {
  const isEditMode = mode === PACKAGE_FORM_MODE.EDIT;
  const formatDisplayDate = () => {
    const [start, end] = data?.dateRange || [];
    if (!start || !end) return "—";

    return (
      <>
        {t("loyaltyPackage.programForm.from")} {formatLoyaltyDatetime(start)}
        <br />
        {t("loyaltyPackage.programForm.to")} {formatLoyaltyDatetime(end)}
      </>
    );
  };

  return (
    <LoyaltyModal
      visible={visible}
      onCancel={onCancel}
      title={
        <LoyaltyModalTextTitle>
          {isEditMode
            ? t("loyaltyPackage.packageForm.confirmUpdateTitle")
            : t("loyaltyPackage.packageForm.confirmCreateTitle")}
        </LoyaltyModalTextTitle>
      }
      footer={<LoyaltyModalFooter onCancel={onCancel} onConfirm={onConfirm} loading={loading} />}
    >
      <div className="loyalty-modal-summary">
        <Row gutter={[16, 12]}>
          <Col span={10}>
            <Text strong>{t("loyaltyPackage.form.packageName")}</Text>
          </Col>
          <Col span={14}>
            <Text>{data?.title}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.form.dateRange")}</Text>
          </Col>
          <Col span={14}>
            <Text>{formatDisplayDate()}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.form.category")}</Text>
          </Col>
          <Col span={14}>
            <Text>{categoryName}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.form.parentProgram")}</Text>
          </Col>
          <Col span={14}>
            <Text>{programTitle}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.package.timeIntervalType")}</Text>
          </Col>
          <Col span={14}>
            <Text>{getLoyaltyTimeIntervalLabel(data?.timeInterval)}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.package.applyScope")}</Text>
          </Col>
          <Col span={14}>
            <Text>{getLoyaltyApplyScopeLabel(data?.applyScope)}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.packageForm.milestoneCount")}</Text>
          </Col>
          <Col span={14}>
            <Text>{milestones?.length ?? 0}</Text>
          </Col>

          <Col span={10}>
            <Text strong>{t("loyaltyPackage.package.numOfProducts")}</Text>
          </Col>
          <Col span={14}>
            <Text>{products?.length ?? 0}</Text>
          </Col>
        </Row>
      </div>

      <Text className="loyalty-modal-warning">
        {isEditMode
          ? t("loyaltyPackage.packageForm.confirmUpdateMessage")
          : t("loyaltyPackage.packageForm.confirmCreateMessage")}
      </Text>
    </LoyaltyModal>
  );
}

export default PackageConfirmModal;
